module.exports = __webpack_public_path__ + "img/noBusinessOrder.1bb31c90.png";